import { IPolicy } from './../../../../models/policy.interface';
import { DialogData, PolicyDialogComponent } from './../policy-dialog/policy-dialog.component';
import { IProgramCycle } from './../../../../models/programcycle.interface';
import { Component, OnInit, Output, EventEmitter, Input, NgZone } from '@angular/core';
import { IOwner } from './../../../../models/owner.interface';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { IDwellingReturned } from './../../../../models/dwellingInput.interface';

import { first } from 'rxjs/operators';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';

declare const google: any;
@Component({
    selector: 'ebb-contact-details',
    templateUrl: './contact-details.component.html',
    styleUrls: ['./contact-details.component.scss'],
    standalone: false
})
export class ContactDetailsComponent implements OnInit {
  public ownerDetailsForm: FormGroup;
  public useForMailing = true;
  public listResults: any[] = [];
  public MailingAddressDisabled = false;
  public loading = false;
  public removeCoownerLabel = "Remove Co-owner";
  public detailsCoownerLabel = "Co-owner Details";
  public addcoownerquestion ="Would you like to add a co-owner to the application?";
  public phone1Alert ="Receive important text alerts to the co-owner's phone number.";
  public phone2Alert ="Receive important text alerts to the co-owner's secondary phone number.";
  @Output() contact: EventEmitter<IOwner> = new EventEmitter<IOwner>();
  @Input() program: IProgramCycle;
  @Input() programs: IProgramCycle[];
  @Input() dwelling$: Subject<IDwellingReturned>;
  @Input() set contactData(value: { firstName: string,  lastName: string, email: string  }) {
  const owner = this.ownerDetailsForm?.get('owner');
if (!owner || !value) return;

owner.get('firstName')?.setValue(value.firstName ?? '', { emitEvent: false });
owner.get('lastName')?.setValue(value.lastName ?? '', { emitEvent: false });
owner.get('emailAddress1')?.setValue(value.email ?? '', { emitEvent: false });
  }
  @Input() set programData (value: IProgramCycle[]) {
    if ( value && value.length > 0 ){
      this.setMailingAddressDisabled(true);
    }
  }

  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  public _userPolicy: IPolicy | DialogData;
  @Input() set userPolicy(value: IPolicy | DialogData) {
    if (value) {
      this.loadMailingData();
    }
    this._userPolicy = value;
  }

  constructor(
    private readonly _fb: FormBuilder,
    private readonly zone: NgZone,
    private readonly stepper: MatStepper,
    public dialog: MatDialog
  ) {
    this.ownerDetailsForm = this._fb.group({
      owner: this._fb.group({
        firstName: ['',
          [
            Validators.required,
            Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/),
            Validators.maxLength(100)
          ]
        ],
        lastName: ['',
          [
            Validators.required,
            Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/),
            Validators.maxLength(100)
          ]
        ],
        telephone1: [null, [Validators.required]],
        emailAddress1: { value: '', disabled: true },
        telephone1sms: { value: false, disabled: true },
        telephone2: [null],
        telephone2sms: { value: false, disabled: true }
      })
    });

    this.ownerDetailsForm.addControl('address1', this._fb.group({
      address1_Line1: [null, [Validators.required, this.validateAddress]],
      address1_Line2: [null, Validators.pattern(/^((?!\@).)*$/)],
      address1_City: [null, [Validators.required, Validators.pattern(/^((?!\@).)*$/)]],
      address1_StateOrProvince: [null, [Validators.required, Validators.pattern(/^((?!\@).)*$/)]],
      address1_PostalCode: [null, [Validators.required, Validators.pattern(/^((?!\@).)*$/)]]
    }));
  }

public validateAddress(c: FormControl) {
  let AddressRegex = /^(\d{1,}[a-zA-Z0-9-/.#]?) [a-zA-Z0-9-/.\s#]+$/; 
    let PoRegex = /\b(p|P)(ost|ostal)?([ \.]*(O|o|0)(ffice)?)?([ \.]*(b|B)(o|O|0)(x|X))\b/;  
  if(PoRegex.test(c.value)){
    return;
  }
    return (AddressRegex.test(c.value)  ) ? null : {
      validateAddress: {
        valid: false
      }
    };
  }

  public ngOnInit(): void {


    if (this.program.typeCode === 700000004) {
      this.removeCoownerLabel = "Remove Additional contact";
      this.detailsCoownerLabel = "Additional contact details";
      this.addcoownerquestion ="Would you like to add a additional contact to the application?";
      this.phone1Alert ="Receive important text alerts to the additional contact phone number.";
  this.phone2Alert ="Receive important text alerts to the additional contact secondary phone number.";
    }

    this.loadMailingData();

    this.ownerDetailsForm.get('owner').get('telephone1').valueChanges.subscribe(val => {
  const hasValue = typeof val === 'string' ? val.trim().length > 0 : !!val;

  if (hasValue) {
        this.ownerDetailsForm.get('owner').get('telephone1sms').enable();
      } else {
        this.ownerDetailsForm.get('owner').get('telephone1sms').setValue(false);
        this.ownerDetailsForm.get('owner').get('telephone1sms').disable();
      }
    });

    this.ownerDetailsForm.get('owner').get('telephone2').valueChanges.subscribe(val => {
       const hasValue = typeof val === 'string' ? val.trim().length > 0 : !!val;

  if (hasValue) {
        this.ownerDetailsForm.get('owner').get('telephone2sms').enable();
      } else {
        this.ownerDetailsForm.get('owner').get('telephone2sms').setValue(false);
        this.ownerDetailsForm.get('owner').get('telephone2sms').disable();
      }
    });

    if (this.ownerDetailsForm.get('owner').get('firstName').value !== '' || this.ownerDetailsForm.get('owner').get('lastName').value !== '') {
      this.ownerDetailsForm.get('owner').get('firstName').disable();
      this.ownerDetailsForm.get('owner').get('lastName').disable();
    }
  }

  public setMailingAddressDisabled ( disabled: boolean): void {
    this.MailingAddressDisabled = disabled;

  }

  public getMailingAddressDisabled (): boolean {
    return this.MailingAddressDisabled;
  }

  public loadMailingData(){
    this.dwelling$.subscribe(dwelling => {
      if(this.useForMailing) {
        if (this.ownerDetailsForm.get('address1')) {
            this.ownerDetailsForm.get('address1').patchValue({
              address1_Line1: dwelling.address_Street,
              address1_Line2: dwelling.address_Street_Line2,
              address1_City: dwelling.address_City,
              address1_StateOrProvince: dwelling.address_State,
              address1_PostalCode: dwelling.address_Zip
          });
        }
      }
    });
  }

  public mailingAddressFormChange(c: MatCheckboxChange): void {
    this.useForMailing = c.checked;
    if (this.useForMailing) {
      this.dwelling$.pipe(first()).subscribe(dwelling => {
          this.ownerDetailsForm.get('address1').patchValue({
            address1_Line1: dwelling.address_Street,
            address1_Line2: dwelling.address_Street_Line2,
            address1_City: dwelling.address_City,
            address1_StateOrProvince: dwelling.address_State,
            address1_PostalCode: dwelling.address_Zip
          });
      });
    }
    if (!this.useForMailing && this._userPolicy?.['address2_Line1']) {
      this.ownerDetailsForm.get('address1').patchValue({
        address1_Line1: this._userPolicy['address2_Line1'],
        address1_Line2: this._userPolicy['address2_Line2'],
        address1_City: this._userPolicy['address2_City'],
        address1_StateOrProvince: this._userPolicy['address2_StateOrProvince'],
        address1_PostalCode: this._userPolicy['address2_PostalCode']
      });
    } else if(!this.useForMailing) {
      this.ownerDetailsForm.get('address1').patchValue({
        address1_Line1: '',
        address1_Line2: '',
        address1_City: '',
        address1_StateOrProvince: '',
        address1_PostalCode: ''
      });
    }
  }

  public coownerChange(add: boolean): void {
    if (!add) {
    this.ownerDetailsForm.removeControl('coowner');
    return;
      }
     if (add) {
      this.ownerDetailsForm.addControl('coowner', this._fb.group({
        coownerFirstName: [null,
          [
            Validators.required,
            Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/),
            Validators.maxLength(100)
          ]
        ],
        coownerLastName: [null,
          [
            Validators.required,
            Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/),
            Validators.maxLength(100)
          ]
        ],
        coownerEmail: [null,
          [
            Validators.email,
            Validators.maxLength(100)
          ]
        ],
        coownerPhone: [null],
        coownerPhoneSMS: { value: false, disabled: true },
        coownerPhoneAlt: [null],
        coownerPhoneAltSMS: { value: false, disabled: true }
      }));

      this.ownerDetailsForm.get('coowner').get('coownerPhone').valueChanges.subscribe(val => {
        const hasValue = typeof val === 'string'  ? val.trim().length > 0   : val != null;
        if (hasValue) {
          this.ownerDetailsForm.get('coowner').get('coownerPhoneSMS').enable();
        } else {
          this.ownerDetailsForm.get('coowner').get('coownerPhoneSMS').setValue(false);
          this.ownerDetailsForm.get('coowner').get('coownerPhoneSMS').disable();
        }
      });

      this.ownerDetailsForm.get('coowner').get('coownerPhoneAlt').valueChanges.subscribe(val => {
        const hasValue = typeof val === 'string'  ? val.trim().length > 0   : val != null;
        if (hasValue) {
          this.ownerDetailsForm.get('coowner').get('coownerPhoneAltSMS').enable();
        } else {
          this.ownerDetailsForm.get('coowner').get('coownerPhoneAltSMS').setValue(false);
          this.ownerDetailsForm.get('coowner').get('coownerPhoneAltSMS').disable();
        }
      });
    } else {
      this.ownerDetailsForm.removeControl('coowner');
    }
  }

  public openDialog(data: DialogData | IPolicy): void {
    const dialogRef = this.dialog.open(PolicyDialogComponent, {
      width: '80%',
      data: {
        address1_Line1: data.address1_Line1,
        address1_Line2: data.address1_Line2,
        address1_City: data.address1_City,
        address1_StateOrProvince: data.address1_StateOrProvince,
        address1_PostalCode: data.address1_PostalCode,
        address1_County: data.address1_County
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitContact(this.ownerDetailsForm.value);       
      }
    });
  }

  public emitContact(contact: IOwner): void {
    this.loading = true;
    if (contact.address1) {
      delete contact.address1.address1;
    }
    this.contact.emit(contact);
    // Set loading back to false after a short delay (assuming the operation completes quickly)
  setTimeout(() => {
    this.loading = false;
    this.stepper.next();
  }, 2000); 
  }

  public nextStepEnabled(form: FormGroup): boolean {
    return form.valid;
  }

  public onFocus(event: Event): void {
    window['angularGooglePlaceDetailRef'] = { component: this, zone: this.zone };
  }

  public openDropdown(suggestions: any[]): void {
        let list = [];
        for (let suggestion of suggestions) {
            const placePrediction = suggestion.placePrediction;
            list.push(placePrediction);
        }
        this.listResults = list;
    }

  public async getPlaceDetails(result: any) {
        if (this.isServiceAvailable()) {
            const place = new google.maps.places["Place"]({
                id: result.placeId
            });

            await place.fetchFields({
                fields: ["displayName", "formattedAddress", "postalAddress", "location"]
            });

            this.fillInAddress(place.postalAddress, null);

        }
    }

    //way to handle google maps library loading async
    //quick way for now to avoid typescript implementation and reference errors
    //https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
    public isServiceAvailable() {
        return true;
    }

     public async fillInAddress(place: any, status: any): Promise<void> {
   
      const address1 = place.addressLines[0];
      
  let address = address1 ?? '';
  let address2 = '';
  let city = place.locality;

  let zip = place.postalCode ?? '';

// Keep only the 5-digit part
if (zip.includes('-')) {
  zip = zip.split('-')[0];
}
  let state = place.administrativeArea.substring(0,2).toUpperCase();
  // Patch your existing reactive form (same control names you used before)
  window['angularGooglePlaceDetailRef'].zone.run(() => {
      const comp = window['angularGooglePlaceDetailRef'].component;
      comp.ownerDetailsForm.get('address1').patchValue({
        address1: `${address.trim()}, ${city.trim()}, ${state.trim()} ${zip.trim()}`,
        address1_Line1: address.trim(),
        address1_Line2: '',
        address1_City: city.trim(),
        address1_StateOrProvince: state.trim(),
        address1_PostalCode: zip.trim()
      }, { emitEvent: false });
      comp.ownerDetailsForm.get('address1').get('address1_Line1').markAsTouched();
      comp.ownerDetailsForm.get('address1').get('address1_Line2').markAsTouched();
      comp.ownerDetailsForm.get('address1').get('address1_City').markAsTouched();
      comp.ownerDetailsForm.get('address1').get('address1_StateOrProvince').markAsTouched();
      comp.ownerDetailsForm.get('address1').get('address1_PostalCode').markAsTouched();

      comp.ownerDetailsForm.get('address1').get('address1_Line1').markAsDirty();
      comp.ownerDetailsForm.get('address1').get('address1_Line2').markAsDirty();
      comp.ownerDetailsForm.get('address1').get('address1_City').markAsDirty();
      comp.ownerDetailsForm.get('address1').get('address1_StateOrProvince').markAsDirty();
      comp.ownerDetailsForm.get('address1').get('address1_PostalCode').markAsDirty();
    });
  }
  

  public onKey(e: any): void {
    const key = e.keyCode;
    let $selected = this.listResults.findIndex(element => element.selected === true);

    if (key === 40) {
      if (!this.listResults.length || this.listResults.length <= $selected + 1) {
        $selected = 0;
      } else {
        $selected += 1;
      }
      for (let i = 0; i <this.listResults.length; i++) {
        if (i === $selected) {
          this.listResults[i].selected = true;
          continue;
        }
        this.listResults[i].selected = false;
      }
    } else if (key === 38) {
      if (!this.listResults.length || $selected <= 0) {
        $selected = this.listResults.length + 1;
      } else {
        $selected -= 1;
      }

      for (let i = 0; i < this.listResults.length; i++) {
        if (i === $selected) {
          this.listResults[i].selected = true;
          continue;
        }
        this.listResults[i].selected = false;
      }
    } else if (key === 13) {
      if (this.listResults.length > 0) {
        console.log(this.listResults[$selected]);
        this.getPlaceDetails(this.listResults[$selected]);
        this.listResults = [];
      }
       e.preventDefault();
    }
  }
}
